import { render, staticRenderFns } from "./TheNewUpload.vue?vue&type=template&id=5a5c5c26&scoped=true"
import script from "./TheNewUpload.vue?vue&type=script&lang=js"
export * from "./TheNewUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5c5c26",
  null
  
)

export default component.exports